import { Box, Grid } from "@mui/material";
import { useFormContext, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FnDialog } from "utilities/utilities";
import { TextBoxItem } from "components/Input/TextBox";
import { BtnAdd, BtnDelete } from "components/Button/ButtonAll";
import { SelectItem } from "components/Input/Select/SelectItem";
import ColorPicker from 'react-pick-color';
import { useEffect } from "react";
import { TextAreaItem } from "components/Input/TextArea";
import { useState } from 'react'

function TextOption({
  arrTextOption,
  setArrTextOption,
  IsTextOption,
  DropdownFontSize,
  FontColor,
  setFontColor,
  DropdownTextPos,
  IsView = false,
  sPlacement,
  setsPlacement,
  IsDisabled
}) {
  const fontColor = "rgb(52, 71, 103)";
  const { t } = useTranslation();
  const DialogFn = FnDialog();

  const formTextOption = useFormContext();

  const [activeId, setActiveId] = useState(null);
  const [IsTextRenderOption, setIsTextRenderOption] = useState();

  useEffect(() => {
    if (arrTextOption != null) {
      arrTextOption.forEach((item, i) => {
        formTextOption.setValue(`sHeadline_${i + 1}`, item.sHeadline);
        formTextOption.setValue(`sHeadlineColor_${i + 1}`, item.sHeadlineColor);
        formTextOption.setValue(`sHeadlineSize_${i + 1}`, item.nHeadlineSize);
      });
    }
  }, [arrTextOption]);

  useEffect(() => {
    setIsTextRenderOption(IsTextOption);
    formTextOption.clearErrors();
  }, [IsTextOption])

  useEffect(() => {
    formTextOption.setValue("sPlacement", sPlacement);
  }, [sPlacement])


  const AddMoreTextOption = () => {
    let arrOption = arrTextOption;
    if (arrOption.length <= 3) {
      let IsError = false;
      arrTextOption.forEach((item, i) => {
        if (formTextOption.getValues(`sHeadline_${i + 1}`) == null || formTextOption.getValues(`sHeadline_${i + 1}`) === "") {
          formTextOption.setError(
            `sHeadline_${i + 1}`,
            { type: "custom", message: "โปรดระบุ ข้อความ" },
            { shouldFocus: true }
          );
          IsError = true;
        }
        if (formTextOption.getValues(`sHeadlineColor_${i + 1}`) == null || formTextOption.getValues(`sHeadlineColor_${i + 1}`) === "") {
          formTextOption.setError(
            `sHeadlineColor_${i + 1}`,
            { type: "custom", message: "โปรดระบุ สีตัวอักษร" },
            { shouldFocus: true }
          );
          IsError = true;
        }
        if (formTextOption.getValues(`sHeadlineSize_${i + 1}`) == null || formTextOption.getValues(`sHeadlineSize_${i + 1}`) === "") {
          formTextOption.setError(
            `sHeadlineSize_${i + 1}`,
            { type: "custom", message: "โปรดระบุ ขนาดตัวอักษร" },
            { shouldFocus: true }
          );
          IsError = true;
        }
      });
      if (IsError) {
        return false;
      }
      let arrOption = arrTextOption;
      let nMaxData =
        arrOption.length > 0 ? Math.max(...arrOption.map((o) => o.nID)) + 1 : 1;

      let moreData = {
        nID: nMaxData,
        sHeadline: "",
        sHeadlineColor: null,
        nHeadlineSize: null,
        nTextOptionID: null,
        sTextMode: "N",
      };
      setArrTextOption([...arrOption, moreData]);
    }
    else {
      DialogFn.Warning("เพิ่มบรรทัดได้สูงสุด 4 บรรทัด", () => { DialogFn.CloseSubmitWarning() });
    }

  };

  const DeleteTextOption = (nID) => {
    DialogFn.Submit(t("deletemsg"), () => {
      formTextOption.unregister(`sHeadline_${arrTextOption.length}`);
      formTextOption.unregister(`sHeadlineColor_${arrTextOption.length}`);
      formTextOption.unregister(`sHeadlineSize_${arrTextOption.length}`);
      let arrText = arrTextOption.toSpliced(nID - 1, 1);
      setArrTextOption([...arrText]);
      DialogFn.CloseSubmit();
    });
  };

  const handleShowColorPicker = (nID, id) => {
    let arr = FontColor;

    arr.forEach(element => {
      element.displayColorPicker = true;
      element.nID = nID;
      element.id = id
    });
    setFontColor([...arr])
    setActiveId(nID);
  }

  const handleCloseColorPicker = (nID, id) => {
    let arr = FontColor;

    arr.forEach(element => {
      element.displayColorPicker = false;
      element.nID = nID;
      element.id = id
    });
    setFontColor([...arr])
  }

  const onChangeColorPicker = (color, sRowColor, id) => {
    let arr = FontColor;
    arr.forEach(element => {
      element.color = color.rgb;
      element.changeColor = color.hex;
    });
    setFontColor([...arr])
    arrTextOption.forEach((item, i) => {
      formTextOption.setValue(sRowColor, color.hex)
    });

    arrTextOption[id].sHeadlineColor = color.hex ?? formTextOption.getValues(sRowColor);
    setArrTextOption([...arrTextOption]);
  }

  return (
    <FormProvider {...formTextOption}>
      <Grid
        container
        spacing={2}
        sx={{
          border: "1px solid #f4f4f4",
          margin: "0.5rem",
          pr: 1.5,
          pb: 1.5,
          display: IsTextRenderOption ? "flex" : "none",
          width: "100%"
        }}
      >
        {(arrTextOption)
          .filter((f) => f.sTextMode !== "D")
          .map((m, i) => (
            <Grid key={m.nID} item container xs={12} spacing={2} justifyContent={"start"} alignItems={"start"}>
              <Grid item xs={5}>
                <Box
                  sx={{
                    color: fontColor,
                  }}
                  className="Box-content-form"
                >
                  {/* <HeaderInput text={`${t("textline")} ${i + 1}`} required={IsTextRenderOption} /> */}
                  <TextAreaItem
                    id={`sHeadline_${i + 1}`}
                    name={`sHeadline_${i + 1}`}
                    label={`${t("textline")} ${i + 1}`}
                    required={IsTextRenderOption}
                    row={1}
                    // placeholder={`${t("textline")} ${i + 1}`}
                    disabled={IsDisabled}
                    maxLength={100}
                    onChange={(e) => {
                      arrTextOption[i].sHeadline = e.target.value;
                      setArrTextOption([...arrTextOption]);
                    }}
                  // type="text"
                  />
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box
                  sx={{
                    color: fontColor,
                    position: "relative"
                  }}
                  className="Box-content-form-color"
                >
                  {/* <HeaderInput text={t("fontcolor")} required={IsTextRenderOption} /> */}

                  <TextBoxItem
                    id={`sHeadlineColor_${i + 1}`}
                    name={`sHeadlineColor_${i + 1}`}
                    label={
                      "-- " + t("select") + " " + t("color") + " --"
                    }
                    required={IsTextRenderOption}
                    // placeholder={`${t("textline")} ${i + 1}`}
                    disabled={IsDisabled}
                    maxLength={7}
                    defaultValue={FontColor.length !== 0 ? FontColor[0].changeColor : null}
                    onChange={(e) => {

                      arrTextOption[i].sHeadlineColor = e.target.value ?? formTextOption.getValues(`sHeadlineColor_${i + 1}`);
                      setArrTextOption([...arrTextOption]);
                    }}
                    onClick={(e) => {
                      handleShowColorPicker(`sHeadlineColor_${i + 1}`, i);
                    }}
                    type="text"
                  />
                  <Box sx={{ position: "absolute" }}>
                    <CallColoPicker
                      FontColor={FontColor}
                      handleCloseColorPicker={handleCloseColorPicker}
                      onChangeColorPicker={onChangeColorPicker}
                      id={`sHeadlineColor_${i + 1}`}
                      activeId={activeId}
                    />
                  </Box>

                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box
                  sx={{
                    color: fontColor,
                  }}
                  className="Box-content-form"
                >
                  {/* <HeaderInput text={t("fontsize")} required={IsTextRenderOption} /> */}
                  <SelectItem
                    id={`sHeadlineSize_${i + 1}`}
                    name={`sHeadlineSize_${i + 1}`}
                    label={
                      "-- " + t("select") + " " + t("size") + " --"
                    }
                    // placeholder={
                    //   "-- " + t("select") + " " + t("size") + " --"
                    // }
                    required={IsTextRenderOption}
                    disabled={IsDisabled}
                    options={DropdownFontSize}
                    onChange={(e) => {
                      arrTextOption[i].nHeadlineSize =
                        e != null ? e.value : e;
                      setArrTextOption([...arrTextOption]);
                    }}
                  />
                </Box>
              </Grid>
              {i !== 0 && (
                <Grid
                  item
                  xs={2}
                  sm={1}
                  display={"flex"}
                  alignItems={"center"}
                >
                  <Box
                    sx={{
                      color: "rgb(52, 71, 103)",
                    }}
                    className=".Box-content-form"
                  >
                    <BtnDelete
                      onClick={() => DeleteTextOption(i + 1)}
                      id={"btnDel"}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          ))}
        {/* <CallColoPicker /> */}
        <Grid item container xs={12} spacing={2} justifyContent={"start"}>
          <Grid item>
            <Box>
              <BtnAdd
                IsDisabled={IsDisabled}
                txt={"เพิ่มรายละเอียด"}
                onClick={() => AddMoreTextOption()}
                id={"btnAdd"}
              // onClick={() => AddMoreTextOption()}
              />
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              color: fontColor,
            }}
            className="Box-content-form"
          >
            {/* <HeaderInput text={t("textplacement")} required={IsTextRenderOption} /> */}
            <SelectItem
              id={"sPlacement"}
              name={"sPlacement"}
              label={
                "-- " + t("select") + " " + t("textplacement") + " --"
              }
              // placeholder={
              //   "-- " + t("select") + " " + t("textplacement") + " --"
              // }
              required={IsTextRenderOption}
              disabled={IsDisabled}
              options={DropdownTextPos}
              onChange={(e) => { setsPlacement(e.value) }}
            />
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
}

export default TextOption;


export const CallColoPicker = ({ FontColor, handleCloseColorPicker, onChangeColorPicker, id, activeId }) => {
  return (
    <>
      {(FontColor[0].displayColorPicker && activeId === id) &&
        <div className="color-picker-palette" style={{ position: "absolute", zIndex: "100" }} id={FontColor[0].nID} key={FontColor[0].nID} >
          <div
            key={id}
            className="color-picker-cover"
            style={{ position: "fixed", top: "0px", bottom: "0px", left: "0px", right: "0px" }}
            onClick={(e) => {
              handleCloseColorPicker(FontColor[0].nID, FontColor[0].id);
            }}
            onKeyDown={() => { }}
          />
          <ColorPicker color={FontColor[0].color} onChange={(color) => { onChangeColorPicker(color, FontColor[0].nID, FontColor[0].id) }} />
        </div>
      }
    </>
  );
}


